const mEditionBillingSalesDataEditData = {
  mEditionBillingSalesDataEditData: {
    alerts: {
      updatePuntoVenta: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El punto de venta fue editado exitosamente.'
      }
    },

    buttonPrimary: 'EDITAR',

    fieldsets: {
      legends: {
        contact: '5. Información de Contacto',
        general: '1. Información General',
        invoice: '3. Información de Comprobante',
        legal: '4. Información Legal',
        location: '2. Información de Ubicación'
      }
    },

    inputs: {
      domicilio: {
        codigo_postal: {
          label: 'Código Postal',
          message: '* De 1 a 10 caracteres'
        },

        linea1: {
          label: 'Dirección Principal',
          message: '* De 1 a 120 caracteres'
        },

        linea2: {
          label: 'Dirección Opcional',
          message: 'De 1 a 120 caracteres'
        },

        localidad: {
          label: 'Localidad',
          message: '* De 1 a 60 caracteres'
        },

        pais: {
          label: 'País'
        },

        provincia: {
          label: 'Provincia',
          message: '* Primero debes seleccionar un país'
        }
      },

      persona: {
        documento_numero: {
          label: 'Número de Documento',
          message: '* De 1 a 45 caracteres'
        },

        documento_tipo: {
          label: 'Tipo de Documento',
          message: '* Primero debes seleccionar un país'
        },

        fisica: {
          label: 'Tipo de Persona'
        },

        movil: {
          label: 'Número de Móvil',
          message: '* De 1 a 60 caracteres'
        },

        razon_social: {
          labelBusiness: 'Razón Social',
          labelName: 'Nombre',
          message: '* De 1 a 60 caracteres'
        },

        telefono: {
          label: 'Número de Teléfono',
          message: '* De 1 a 60 caracteres'
        }
      },

      punto_venta: {
        comprobante_tipo: {
          label: 'Tipo de Comprobante',
          message: '* Primero debes seleccionar un país'
        },

        divisa: {
          label: 'Moneda (divisa)'
        },

        divisa_emite: {
          label: 'Emite (divisa)'
        },

        divisa_vende: {
          label: 'Vende (divisa)'
        },

        mensaje_pie: {
          label: 'Nota Legal',
          message: '* De 1 a 255 caracteres'
        },

        nombre: {
          label: 'Nombre de Punto de Venta',
          placeholder: 'Mi Punto de Venta',
          message: '* De 1 a 60 caracteres'
        },

        numero: {
          label: 'Código Inicial',
          message: '* De 1 a 10 caracteres',
          tooltip: 'El sistema generará la numeración de cada comprobante colocando el año actual y el número incremental luego del código inicial que introduzcas. Ej: "ABC-2021-00"'
        }
      }
    },

    title: 'EDITAR PUNTO DE VENTA',

    validation: {
      domicilio: {
        codigo_postal: {
          maxLength: 'La longitud máxima permitida es de 10 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Código Postal es requerido.'
        },

        linea1: {
          maxLength: 'La longitud máxima permitida es de 120 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Primera línea de dirección es requerida.'
        },

        linea2: {
          maxLength: 'La longitud máxima permitida es de 120 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.'
        },

        localidad: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Localidad es requerida.'
        },

        pais: {
          required: 'Pais es requerido.'
        },

        provincia: {
          required: 'Provincia es requerida. Primero debes seleccionar un país.'
        }
      },

      persona: {
        documento_numero: {
          maxLength: 'La longitud máxima permitida es de 45 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de Documento es requerido.'
        },

        documento_tipo: {
          required: 'Tipo documento es requerido. Primero debes seleccionar un país.'
        },

        fisica: {
          required: 'Tipo persona es requerido.'
        },

        movil: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de móvil es requerido.'
        },

        razon_social: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Dato requerido.'
        },

        telefono: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Número de teléfono es requerido.'
        }
      },

      punto_venta: {
        comprobante_tipo: {
          required: 'Tipo comprobante es requerido. Primero debes seleccionar un país.'
        },

        divisa: {
          required: 'Moneda (divisa) es requerida.'
        },

        mensaje_pie: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Nota Legal es requerida.'
        },

        nombre: {
          maxLength: 'La longitud máxima permitida es de 60 caracteres.',
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          required: 'Nombre de punto de venta es requerido.'
        },

        numero: {
          minLength: 'La longitud mínima permitida es de 1 caracteres.',
          maxLength: 'La longitud máxima permitida es de 10 caracteres.',
          required: 'Código Inicial de punto de venta es requerido.'
        }
      }
    }
  }
}

export default mEditionBillingSalesDataEditData
